import axios from "axios";

// export makes function importable in other modules
export function trackEvent (event) {
    axios.put('/track/event', {
        event
    }).then(function (resp) {

    })
}
// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const analyticsModule = {
    trackEvent,
}